import { render, staticRenderFns } from "./FormBuilderEdit.vue?vue&type=template&id=6f41b140&"
import script from "./FormBuilderEdit.vue?vue&type=script&lang=js&"
export * from "./FormBuilderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports